module.exports = __webpack_public_path__ + "img/06-02-zl-p11.4032937f.png";